import { render } from "./About.vue?vue&type=template&id=e4c4a026"
const script = {}

import exportComponent from "/Users/frankreinshome/Development/otiplayer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__